import styled from "styled-components";
import { PageBox } from "../../../styles/page";
export * from "./memberTable.style";
export const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 50px 0 30px;

  font-family: Pretendard;
`;

export const PageHeader = styled.div`
  position: relative;
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
  text-align: left;
  padding: 50px 30px 30px 0px;
`;

export const MainWrapper = styled.div`
  padding-bottom: 50px;
  font-family: Pretendard;
  height: auto;
  background: #ffffff;
  display: flex;
  gap: 32px;
`;

export const GraphWrapper = styled(PageBox)`
  flex: 1;
  border: 0.71px solid #d9d9d9;
  padding: 40px;
  height: 908px;

  > .header {
    margin-bottom: 40px;

    > .drop-box {
      width: 103px;
      height: 27px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      cursor: pointer;

      > .value {
        color: #121212;
        font-family: Pretendard;
        font-size: 23px;
        font-weight: 700;
      }

      > img {
        width: 7px;
        height: auto;
      }

      > .drop-box-wrapper {
        background-color: #fff;
        width: 105px;
        z-index: 1001;
        top: 40px;
        position: absolute;
        border-radius: 3px;
        border: 1px solid var(--Black-200, #b7b7b7);
        display: flex;
        flex-direction: column;

        > .item {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;

          > img {
            width: 14.196px;
            height: auto;
            margin-right: 5px;
          }

          > span {
            padding: 5.396px 8.093px;
            color: #121212;
            font-family: Pretendard;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }
  }

  > .main-box {
    display: flex;
    gap: 26px;
    width: 100%;

    > .box {
      display: flex;
      flex-direction: column;
      flex: 1;
      background: #ecf0f3;
      height: 163px;
      border-radius: 21.57px;
      padding: 28px 23px;
      box-sizing: border-box;
      gap: 11px;
      justify-content: space-between;

      > .title {
        font-family: Pretendard;
        font-size: 21.57px;
        font-weight: 500;
        text-align: left;
      }

      > .value {
        font-family: Pretendard;
        font-size: 53.92px;
        font-weight: 600;
        text-align: left;
      }
    }
  }
`;

export const MemberGraphWrapper = styled.div`
  width: 100%;
  height: 519px;
  margin-top: 70px;

  #chartjs-tooltip {
    position: absolute;
    background-size: cover;
    border-radius: 6px;
    pointer-events: none;
    transition: all 0.1s ease;
    opacity: 0;
    width: 177px;
    height: 103px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    background-image: url("/image-web/solution/tooltip.svg");

    > .wrapper {
      padding: 10px 15px;

      > .header {
        color: #3c3c4399;
        font-family: Pretendard;
        font-size: 10.85px;
        font-weight: 400;
        margin-bottom: 7.8px;
      }

      > .content {
        display: flex;
        flex-direction: column;

        > .info {
          display: flex;
          justify-content: space-between;
          font-family: Pretendard;
          font-size: 14.63px;
          font-weight: 600;

          > .value {
            font-weight: 700;
          }
        }
      }
    }
  }
  #line {
    width: 0px;
    border-right: 2px dashed #422f8ade;
    position: absolute;
  }
`;

export const MemberWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 17px;
`;

export const SearchWrapper = styled(PageBox)`
  border: 0.71px solid #d9d9d9;
  border-radius: 14.26px;
  padding: 40px 40px 0;
  height: 192px;
  display: flex;
  justify-content: space-between;
`;

export const SearchMemberInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  align-items: flex-end;
  position: relative;

  > input {
    width: 383px;
    height: 36px;
    padding: 10px 15px;
    border-radius: 15px;
    box-sizing: border-box;
    border: 1px solid #bebebe;
  }

  > input:focus {
    border-color: rgb(112, 112, 112);
    outline: none;
  }
`;

export const SearchMemberWaring = styled.div`
  position: absolute;
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 500;
  text-align: right;
  color: #f00;
  top: -20px;
`;

export const SearchMemberInfo = styled.div<{
  isRed: boolean;
}>`
  height: 35px;
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 500;
  text-align: right;
  color: ${(p) => (p.isRed ? "#F00" : "#6436e7")};
  padding-bottom: 32px;
`;

export const SearchMemberResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 370px;

  > .box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .name {
      flex: 1;
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 600;
      color: #1a191a;
    }

    > .value {
      width: 160px;
      width: 274px;
      height: 35px;
      box-sizing: border-box;
      padding: 10px 15px;
      border-radius: 15px;
      border: 1px solid #bebebe;
      background: #ecf0f3;
      line-height: 15px;
      font-family: Pretendard;
      font-size: 12px;
      font-weight: 600;
    }
  }
`;

export const SearchButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: 23px;

  > .cancel-button {
    color: #6436e7;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    align-items: center;
    width: 120px;
    cursor: pointer;
    height: 36px;
    padding: 10px 15px;
    box-sizing: border-box;
  }
`;

export const SearchMemberButton = styled.div<{ isGray: boolean }>`
  height: 36px;
  flex: 1;
  box-sizing: border-box;
  border-radius: 15px;
  background: ${(p) => (p.isGray ? "#bebebe" : "#6436e7")};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  align-items: center;
  margin-top: 5px;
  padding: 10px 15px;
  cursor: pointer;
`;
